import { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import AiDebtRecovery from "../assets/img/AiDebtRecovery.png";

import { LuCircleDot, LuClock3, LuGlobe, LuShield } from "react-icons/lu";

import "../assets/css/AIDebtRecovery.css";

const capabilities = [
  {
    icon: <LuCircleDot />,
    title: "Risk-Based Prioritization",
    text: "AI scores every account by likelihood-to-pay and recommends who to contact, when, and through which channel so your team spends effort where it actually moves the number.",
  },
  {
    icon: <LuClock3 />,
    title: "Personalized Repayment Plans",
    text: "Plans are proposed based on account history and affordability signals, not a fixed script automatically matched to what each customer can actually manage.",
  },
  {
    icon: <LuGlobe />,
    title: "Omni-Channel Outreach",
    text: "SMS, email, voice, and WhatsApp reminders, plus self-service payment links so customers can resolve on their own terms and their own schedule.",
  },
  {
    icon: <LuShield />,
    title: "Compliance-First Design",
    text: "Required disclosures, consent rules, and contact-frequency limits are enforced automatically; compliance built into the workflow, not checked after the fact.",
  },
];

const AIDebtRecovery = () => {
  const [, setShow] = useState(false);
  return (
    <div id="ai-debt-recovery">
      <Navbar />

      {/* HERO */}
      <section className="debt-hero">
        <div className="container debt-hero-grid">
          <div className="debt-hero-content">
            <span className="section-tag">AI DEBT RECOVERY</span>

            <h1>
              Recover more.
              <wbr /> Damage less.
            </h1>

            <p>
              Our AI Debt Recovery replaces one-size-fits-all collections with a
              system that knows who to contact, when, and how, turning recovery
              into an engagement problem you can actually solve, not just a
              chase you have to run.
            </p>

            <button className="ccsnl-btn" onClick={() => setShow(true)}>
              Request Consultation
            </button>
          </div>

          <div className="debt-hero-image">
            {/* Replace with your image */}
            <img src={AiDebtRecovery} alt="AI Debt Recovery" />
          </div>
        </div>
      </section>

      {/* INTRO */}
      <section className="debt-intro">
        <div className="container">
          <h2>
            Debt Recovery Is an Engagement Problem, Not Just a Chasing Problem
          </h2>

          <p>
            Most collections systems treat every past-due account the same way:
            same script, same channel, same escalation timeline. Outcess AI Debt
            Recovery scores each account individually and builds the contact
            strategy around what's actually likely to get it paid — protecting
            the customer relationship and your recovery rate at the same time.
          </p>
        </div>
      </section>

      {/* CAPABILITIES */}
      <section className="debt-capabilities">
        <div className="container debt-capabilities-grid">
          <div className="debt-capabilities-content">
            <span className="section-tag">CORE CAPABILITIES</span>

            <h2>
              Built for Recovery,
              <br />
              Not Just Contact
            </h2>

            <p>
              Four capabilities working together — not four separate tools
              bolted onto a legacy collections process.
            </p>
          </div>

          <div className="debt-capabilities-cards">
            {capabilities.map((item, index) => (
              <div
                key={index}
                className="debt-capability-card"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="debt-capability-icon">{item.icon}</div>

                <h4>{item.title}</h4>

                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="debt-cta">
        <h2>Recovery That Doesn't Cost You the Relationship</h2>

        <p>
          Book a consultation and see how risk-based, compliance-first AI
          collections can improve recovery without damaging the customer
          relationships you've worked to build.
        </p>
        <button className="ccsnl-btn" onClick={() => setShow(true)}>
          Request Consultation
        </button>
      </section>

      <Footer />
    </div>
  );
};

export default AIDebtRecovery;
